import React from 'react';
import Contents from 'components/Layout/Contents';

export default function Templates() {
  return (
    <Contents>
      <h1>Sorry!</h1>
      <p>This page is currently under construction.</p>
    </Contents>
  );
}
